import {useCmsUrl} from '@aboutyou/config';
import WebSDK from '@ay-cms/cms-web-sdk';
import {useEffect} from 'react';
import {usePreviewSessionId} from '../usePreviewSessionId';

export const useCmsWebSDK = () => {
  const previewSessionId = usePreviewSessionId();
  const cmsUrl = useCmsUrl();

  useEffect(() => {
    let canceled = false;
    let webSDK: WebSDK;

    if (previewSessionId) {
      const initWebSDK = async () => {
        webSDK = (await import('./cmsWebSDK')).getWebSDK(cmsUrl);

        if (!canceled) {
          webSDK.startSession();
        }
      };

      initWebSDK();
    }

    return () => {
      canceled = true;

      if (webSDK) {
        webSDK.endSession();
      }
    };
  }, [previewSessionId, cmsUrl]);
};
